import { useState } from "react";
import PropTypes from "prop-types";
import { Modal } from "@/config/antd";
import { CloseOutlined } from "@/config/antd";
import Button from "@/components/common/Button";
import InviteUserFormModal from "@/pages/user_management/components/Invite_User_Form_Modal";

const RadioToggle = ({ isActive, label, description, onClick }) => (
  <div
    className={`flex items-start gap-4 cursor-pointer p-4 rounded-lg ${
      isActive ? "bg-secondary" : "bg-white"
    }`}
    onClick={onClick}>
    <div
      className={`min-w-[20px] min-h-[20px] rounded-full border-2 flex items-center justify-center
        ${
          isActive ? "border-primary bg-primary" : "border-lightGrey bg-white"
        }`}
      style={{ width: "20px", height: "20px" }}>
      {isActive && (
        <div
          className="rounded-full bg-white flex items-center justify-center"
          style={{ width: "14px", height: "14px" }}>
          <div
            className="rounded-full bg-primary"
            style={{ width: "8px", height: "8px" }}
          />
        </div>
      )}
    </div>
    <div className="flex flex-col gap-2">
      <span className="text-bold-x text-lighterGrey">{label}</span>
      <span className="text-small text-lighterGrey">{description}</span>
    </div>
  </div>
);

RadioToggle.propTypes = {
  isActive: PropTypes.bool,
  label: PropTypes.string,
  description: PropTypes.string,
  onClick: PropTypes.func,
};

const AddUserModal = ({ isVisible, onClose, userProfile }) => {
  const [selectedOption, setSelectedOption] = useState("member");
  const [showInviteForm, setShowInviteForm] = useState(false);

  const handleProceed = () => {
    setShowInviteForm(true);
  };

  const handleUserCreated = () => {
    setShowInviteForm(false);
    onClose(); // Close the parent modal
  };

  return (
    <>
      <Modal
        open={isVisible}
        onCancel={onClose}
        footer={null}
        centered
        width={600}
        closeIcon={null}
        styles={{
          body: { padding: 0 },
          content: {
            padding: 0,
            borderRadius: "16px",
            overflow: "hidden",
          },
          mask: { backgroundColor: "rgba(0, 0, 0, 0.75)" },
        }}>
        <div className="flex flex-col bg-white">
          {/* Header */}
          <div className="p-4 px-6 flex justify-between items-center">
            <h2 className="heading-regular text-primary">
              Invite a New Member
            </h2>
            <CloseOutlined
              onClick={onClose}
              className="cursor-pointer"
              style={{
                color: "var(--veegil-color-primary)",
                backgroundColor: "var(--veegil-color-lighter-blue)",
                borderRadius: "50%",
                padding: "4px",
              }}
            />
          </div>

          {/* Content Area */}
          <div className="flex flex-col px-10 pb-10 space-y-6">
            <RadioToggle
              isActive={selectedOption === "member"}
              label={`Someone who works at ${
                userProfile?.organizationName || "this organization"
              }`}
              description={`People who work at ${
                userProfile?.organizationName || "this organization"
              } are the only people who can create projects, add others to projects and act as admins, add them this way if they are full-time, part-time, or a volunteer at ${
                userProfile?.organizationName || "this organization"
              }`}
              onClick={() => setSelectedOption("member")}
            />

            <div className="bg-secondary w-full h-2"></div>

            <RadioToggle
              isActive={selectedOption === "guest"}
              label="A Collaborator, Partner, or Guest"
              description="They can collaborate on projects with you but won't be able to create projects, and invite people to the account or become admins."
              onClick={() => setSelectedOption("guest")}
            />
          </div>

          {/* Footer */}
          <div className="w-full bg-secondary p-4">
            <Button
              text="PROCEED"
              color="primary"
              className="w-full"
              customBgColor="primary"
              customTextColor="white"
              onClick={handleProceed}
            />
          </div>
        </div>
      </Modal>

      <InviteUserFormModal
        isVisible={showInviteForm}
        onClose={() => setShowInviteForm(false)}
        onUserCreated={handleUserCreated}
        userType={selectedOption}
      />
    </>
  );
};

AddUserModal.propTypes = {
  isVisible: PropTypes.bool,
  onClose: PropTypes.func,
  userProfile: PropTypes.object,
};

export default AddUserModal;
